import React from 'react';
import AboutMe from '../data/constant';
import Projects from '../components/Projects';
import Experience from '../components/Experience';
import Skills from '../components/Skills';
import Profiles from '../components/Profiles';
import Photos from './Photos';

const StartMenu = ({ isVisible, handleDoubleClick }) => {

  

  if (!isVisible) {
    return null;
  }

  return (
    <div className="absolute bottom-12 left-2 w-64 bg-gray-700 p-4 rounded-lg shadow-lg">
      <ul className='text-white'>
        <li className="py-2 hover:bg-gray-600 rounded-md" onClick={() => handleDoubleClick('About me', <AboutMe />)}>About Me</li>
        <li className="py-2 hover:bg-gray-600 rounded-md" onClick={() => handleDoubleClick('Projects', <Projects />)}>Projects</li>
        <li className="py-2 hover:bg-gray-600 rounded-md" onClick={() => handleDoubleClick('Experience', <Experience />)}>Experience</li>
        <li className="py-2 hover:bg-gray-600 rounded-md" onClick={() => handleDoubleClick('Skills', <Skills />)}>Skills</li>
        <li className="py-2 hover:bg-gray-600 rounded-md" onClick={() => handleDoubleClick('profiles', <Profiles />)}>Profiles</li>
        <li className="py-2 hover:bg-gray-600 rounded-md" onClick={() => handleDoubleClick('Photos', <Photos />)}>Photos</li>
      </ul>

    </div>
  );
};

export default StartMenu;
